import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useCallback, useContext } from 'react'

import Button from '@/components/base/Button'
import useNemoWallet from '@/hooks/use-nemo-wallet'
import useTrans from '@/hooks/useTrans'

import { AssetWithdrawalContext } from '../context'

const WithdrawalConnectWallet = () => {
  const trans = useTrans()
  const { connectWallet } = useNemoWallet()
  const { selectedToken, setSelectedToken } = useContext(AssetWithdrawalContext)

  const handleClick = useCallback(() => {
    connectWallet()
    setSelectedToken(null)
  }, [setSelectedToken, connectWallet])

  if (!selectedToken) return null

  return (
    <Box>
      <Typography className="text-sm font-semibold">{trans.asset_withdrawal.you_can_trade(selectedToken.displaySymbol ?? '')}</Typography>
      <Typography className="text-sm font-semibold mt-3 mb-[24px]">{trans.asset_withdrawal.connect_first}</Typography>
      <Button
        data-testid="assets-withdraw-connect-wallet"
        onClick={handleClick}
        variant="outlined"
        fullWidth
        size="xl"
      >
        <span className="text-gradient">{trans.common.connect_wallet}</span>
      </Button>
    </Box>
  )
}

export default WithdrawalConnectWallet
